<template>
  <div id="app">
    <div class="pc" v-if="isMobile == false">
      <!-- 头部 -->
      <div>
        <!-- <a href="https://china.mro365.com/activityTemplate?template_id=21">
          <el-image
            :src="'post2.jpg' | imagePath"
            fit="contain"
            style="width: 100%"
          ></el-image>
        </a> -->
        <!-- <div style="background:#e70012;">
          <el-image
            :src="'post3.jpg' | imagePath"
            fit="contain"
            style="width: 1200px;display:block;margin:auto"
          ></el-image>
        </div> -->
        <div class="headBox">
          <div class="bodyWrap head">
            <div class="head-l">
              <span
                >您好，欢迎来到网站
                <a class="backIndex" :href="'index' | hrefFormat">首页</a>
              </span>
              <div class="head-user" v-show="isLogin">
                <a :href="'Mine/account' | hrefFormat" class="head-user-avatar">
                  <el-image :src="avatar" fit="cover">
                    <div slot="error" class="image-slot">
                      <el-image
                        :src="'tacitlyAvatra.png' | imagePath"
                      ></el-image>
                    </div>
                  </el-image>
                </a>
                <p>
                  <a :href="'Mine/account' | hrefFormat">{{ nickname }}</a>
                  {{ company_name === "" ? "" : "-" }}
                  <a :href="'Mine/mineEnterprise' | hrefFormat">
                    {{ company_name === "" ? "" : company_name }}
                  </a>
                </p>
                <span class="head-user-register" @click="logout()">退出</span>
              </div>
              <div class="head-user" v-show="!isLogin">
                <span
                  class="head-user-logo pointer"
                  @click="$.router.push('login')"
                  >请登录</span
                >
                <span
                  class="head-user-register pointer"
                  @click="$.router.push('register')"
                  >免费注册</span
                >
              </div>
            </div>
            <div class="head-r">
              <p @click.prevent="userIsLogin(0)">
                <a :href="'account' | hrefFormat">账户中心</a>
              </p>
              <span>|</span>
              <p @click.prevent="userIsLogin(1)">
                <a :href="'mineOrder' | hrefFormat">我的订单</a>
              </p>
              <span>|</span>
              <a :href="'help' | hrefFormat">帮助中心</a>
              <span>|</span>
              <p
                @click.prevent="userIsLogin(3)"
                style="position: relative; margin-right: 10px"
              >
                <a :href="'news' | hrefFormat">
                  消息中心
                  <em v-show="newsNum !== 0" @newsNumChange="newsNum = 0">{{
                    newsNum
                  }}</em>
                </a>
                <span
                  v-show="unreadNewsTotal > 0"
                  style="
                    background-color: #e60012;
                    display: block;
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    position: absolute;
                    top: 0px;
                    right: -8px;
                  "
                ></span>
              </p>
              <p class="head-hotline">
                咨询热线：<a style="color: #f00">400-600-7758</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- 中间部分 -->
      <div class="bodyCenter" style="position: relative">
        <keep-alive>
          <router-view
            v-if="$route.meta.keepAlive"
            v-wechat-title="$route.meta.title"
          ></router-view>
          <!-- <transition> </transition> -->
        </keep-alive>
        <!-- <transition> </transition> -->
        <router-view
          v-if="!$route.meta.keepAlive"
          v-wechat-title="$route.meta.title"
        ></router-view>
      </div>
      <!-- 底部 -->
      <div>
        <div class="footer">
          <div class="footer-main bodyWrap">
            <div class="footer-list-box">
              <div class="footer-list">
                <img :src="'icon_footer1.png' | imagePath" />
                <div class="footer-first-list">
                  <h1>使用指南</h1>
                  <p
                    style="display: block; line-height: 25px"
                    v-for="(item, index) in footerFirst"
                    :key="index"
                  >
                    <a
                      class=""
                      :href="item.href | hrefFormat"
                      target="_blank"
                      >{{ item.name }}</a
                    >
                  </p>
                </div>
              </div>
              <div class="footer-list">
                <img :src="'icon_footer2.png' | imagePath" />
                <div class="footer-first-list">
                  <h1>客户关怀</h1>
                  <p
                    style="display: block; line-height: 25px"
                    v-for="(item, index) in footerSecond"
                    :key="index"
                  >
                    <a
                      class=""
                      :href="item.href | hrefFormat"
                      target="_blank"
                      >{{ item.name }}</a
                    >
                  </p>
                </div>
              </div>
              <div class="footer-list">
                <img :src="'icon_footer3.png' | imagePath" />
                <div class="footer-first-list">
                  <h1>诚邀加入</h1>
                  <p
                    style="display: block; line-height: 25px"
                    v-for="(item, index) in footerThird"
                    :key="index"
                  >
                    <!-- 内部地址 -->
                    <a
                      class=""
                      :href="item.href | hrefFormat"
                      target="_blank"
                      v-if="item.type == 1"
                      >{{ item.name }}</a
                    >
                    <!-- 外部地址 -->
                    <a
                      class=""
                      :href="item.href"
                      target="_blank"
                      v-if="item.type == 2"
                      >{{ item.name }}</a
                    >
                  </p>
                  <p style="height: 25px">&nbsp;</p>
                </div>
              </div>
              <div class="footer-list">
                <img :src="'icon_footer4.png' | imagePath" />
                <div class="footer-first-list">
                  <h1>友情链接</h1>
                  <p
                    style="display: block; line-height: 25px"
                    v-for="(item, index) in footerFourth"
                    :key="index"
                  >
                    <!-- 内部地址 -->
                    <a
                      class=""
                      :href="item.href | hrefFormat"
                      target="_blank"
                      v-if="item.type == 1"
                      >{{ item.name }}</a
                    >
                    <!-- 外部地址 -->
                    <a
                      class=""
                      :href="item.href"
                      target="_blank"
                      v-if="item.type == 2"
                      >{{ item.name }}</a
                    >
                  </p>
                </div>
              </div>
            </div>
            <div class="footer-phone">
              <i>{{ basic.WEB_SERVICE_TELEPHONE }}</i>
              <p>服务热线</p>
            </div>
            <div class="footer-sixth footer-scan">
              <img :src="basic.QRCODE_DOWNLOAD_IOS" />
              <p>iOS下载</p>
            </div>
            <div class="footer-sixth footer-scan">
              <img :src="basic.QRCODE_DOWNLOAD_ANDROID" />
              <p>安卓下载</p>
            </div>
          </div>
        </div>
        <div class="root">
          <p>
            Copyright {{ systemTime }} ©️
            {{ basic.WEB_COPYRIGHT_INFO }} 版权所有
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">
              {{ basic.WEB_RECORD_NO }}
            </a>
            备案号：
            <!-- 医疗备案：改为动态配置 -->
            <a
              v-if="basic.MEDICAL_RECORD && basic.MEDICAL_RECORD_FILE"
              :href="basic.MEDICAL_RECORD_FILE"
              target="_blank"
              rel="noopener"
            >
              {{ basic.MEDICAL_RECORD }}
            </a>
            <!-- 原先这个证照链接如果仍要保留，可继续保留 -->
            <a href="https://china.mro365.com/resources/ca.png" target="_blank" rel="noopener">
              互联网药品信息服务资格证编号（沪）-经营性-2023-0137
            </a>
          </p>

          <!-- 公安备案：居中放到最底下（新增模块） -->
          <p
            class="public-security-filing"
            v-if="basic.PUBLIC_SECURITY_FILING && publicSecurityRecordCode"
          >
            <a
              :href="publicSecurityLink"
              target="_blank"
              rel="noopener"
            >
              <img
                class="public-security-icon"
                :src="mpsIcon"
                alt="公安备案"
              />
              {{ basic.PUBLIC_SECURITY_FILING }}
            </a>
          </p>

          <p>
            建议您使用Chrome、Firefox、Edge、IE10及以上版本和360等主流浏览器浏览本网站
          </p>
        </div>

      </div>
      <template v-if="!isCloseAdv">
        <!-- 底部广告位置 -->
        <div class="pc_bottom_adv" :class="isTinyAdv ? 'hide' : ''">
          <a href="https://china.mro365.com/register" rel="nofollow">
            <el-image
              :src="'post3.png' | imagePath"
              fit="contain"
              style="width: 100%"
            ></el-image>
          </a>
          <i class="el-icon-close" id="adv_close" @click="isTinyAdv = true"></i>
        </div>
        <!-- 底部广告位置缩小 -->
        <div class="pc_bottom_fixed_adv" :class="!isTinyAdv ? 'hide' : ''" @click="hideAdvClick">
          <el-image
            :src="'post3_tiny.jpg' | imagePath"
            fit="cover"
          ></el-image>
          <i class="el-icon-close" id="adv_fixed_close" @click.stop="closeBottomFixedAdv"></i>
        </div>
      </template>
    </div>
    <template v-if="isMobile == true">
      <keep-alive>
        <router-view
          v-if="$route.meta.keepAlive"
          v-wechat-title="$route.meta.title"
        ></router-view>
      </keep-alive>
      <router-view
        v-if="!$route.meta.keepAlive"
        v-wechat-title="$route.meta.title"
      ></router-view>
    </template>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      mpsIcon: require('@/assets/images/mps.gov.png'),
      basic: {},
      isLogin: false,
      avatar: "",
      nickname: "",
      company_name: "",
      baseUrl: "",
      systemTime: null,
      name: "",
      newsNum: 0,
      footerFirst: [
        { name: "购物流程", href: "help?type=117" },
        { name: "操作手册", href: "help?type=105" },
        { name: "注册指南", href: "help?type=106" },
        { name: "意见反馈", href: "idea" },
      ],
      footerSecond: [
        { name: "退换货流程", href: "help?type=107" },
        { name: "服务承诺", href: "help?type=108" },
        { name: "售后服务", href: "help?type=109" },
        { name: "银行汇款", href: "help?type=110" },
      ],
      footerThird: [
        {
          name: "PPE服务外包",
          href: "https://www.mro365.com/helpcenter/333.html",
          type: 2,
        },
        {
          name: "供应商加入",
          href: "https://www.mro365.com/helpcenter/16.html ",
          type: 2,
        },
        {
          name: "诚邀经销商",
          href: "https://www.mro365.com/helpcenter/15.html",
          type: 2,
        },
      ],
      footerFourth: [
        { name: "馥信体系认证", href: "http://www.faithverify.com/", type: 2 },
        { name: "超网验厂咨询", href: "http://www.sa8000cn.cn", type: 2 },
        { name: "上海之安商城", href: "http://www.ppechina.com/", type: 2 },
      ],
      unreadNewsTotal: 0,
      isTinyAdv: false, //大小广告互相切换
      isCloseAdv: false, //完全关闭广告，3小时后再显示
      advType: 1, //  1大小adv都显示，0只显示adv
    };
  },
  computed: {
    isMobile() {
      return this.$route.meta.isMobile;
    },
    // 从 “苏公网安备 32058302001623号” 中提取纯数字：32058302001623
    publicSecurityRecordCode() {
      const s = (this.basic && this.basic.PUBLIC_SECURITY_FILING) ? String(this.basic.PUBLIC_SECURITY_FILING) : "";
      const m = s.match(/(\d{6,})/); // 至少 6 位数字，避免误匹配
      return m ? m[1] : "";
    },

    // 拼接政府网站链接
    publicSecurityLink() {
      const code = this.publicSecurityRecordCode;
      if (!code) return "";
      return `https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${code}`;
    },
  },
  methods: {
    userIsLogin(type) {
      if (this.isLogin) {
        if (type == 0) {
          this.$.router.push("account");
        } else if (type == 3) {
          this.$.router.push("news");
        } else if (type == 1) {
          this.$.router.push("mineOrder");
        }
      } else {
        var fromUrl = ["account", "mineOrder", "", "news"][type];
        this.$.router.replace("/login", { fromUrl: fromUrl });
      }
    },
    // 获取接触配置
    getBasic() {
      this.$.http
        .post("basic/basicConfigs", "", false, false, false)
        .then((res) => {
          this.basic = res.data;
          this.$.storage.setItem(
            "hotSearchWord",
            res.data.INDEX_PAGE_HOT_KEYWORDS
          );
          this.$.storage.setItem(
            "changwei_CUSTOMER_SERVICE_TELEPHONE",
            res.data.CUSTOMER_SERVICE_TELEPHONE
          );
          let head = document.getElementsByTagName("head")[0];
          let title = document.getElementsByTagName("title")[0];
          let meta = document.createElement("meta");
          meta.content = res.data.WEB_KEYWORDS;
          meta.name = "keywords";
          let meta1 = document.createElement("meta");
          meta1.content = res.data.WEB_DESCRIPTION;
          meta1.name = "description";
          head.insertBefore(meta, title);
          head.insertBefore(meta1, title);
        });
    },
    // 获取用户信息
    getPersonDetail() {
      this.$.http
        .post("center/detail", "", "", false, false, false)
        .then((res) => {
          res = res.data;
          this.avatar = res.avatar;
          this.nickname = res.nickname;
          this.company_name = res.company_name;
          this.$.storage.setItem("changwei_role_type", res.role_type);
        });
    },
    // 退出登录
    logout() {
      this.$.storage.clear();
      this.getBasic();
      this.$.notification.emit("login");
      this.$.router.replace("login");
      this.$store.dispatch("cart/ResetCartList");
      this.$store.dispatch("coupon/ResetCouponList");
    },
    // 获取未读消息
    getNewsUnread() {
      this.$.http
        .post("center/message/getUnreadCounts", "", false, false, false)
        .then((res) => {
          this.unreadNewsTotal = res.data.total_counts;
          // console.info(this.unreadNewsTotal);
        });
    },
    closeBottomFixedAdv(){
      this.$.http.setCookie("fixedAdv","0");
      this.isCloseAdv = true
    },
    initFixedAdv(){
      const role_type = this.$.storage.getItem('changwei_role_type')
      if(!role_type || role_type == 1){
        this.isCloseAdv = false
      } else {
        this.isCloseAdv = true
      }
      if(this.$.http.getCookie("fixedAdv") == 0){
        this.isCloseAdv = true
      }
    },
    hideAdvClick(){
      const { advType } = this
      if(advType == 1){
        this.isTinyAdv = false
      }else{
        const template_id = 26
        window.open("https://china.mro365.com/activityTemplate?template_id=" + template_id);
      }
    }
  },
  mounted() {
    // 获取基础数据
    this.systemTime = new Date().getFullYear();
    this.getBasic();
    const isLogin = (this.isLogin = this.$.user.userLogin());
    if (isLogin) {
      this.getPersonDetail();
      this.getNewsUnread();
    }
    // 个人信息修改时监听
    this.$.notification.on("personInfoChange", (res) => {
      this.getPersonDetail();
    });
    // 消息未读数量监听
    this.$.notification.on("newsRead", (res) => {
      this.getNewsUnread();
    });
    // 登录状态监听
    this.$.notification.on("login", (bo) => {
      console.info(bo);
      this.isLogin = bo == 1;
      this.getPersonDetail();
    });

    this.initFixedAdv() //初始化底部广告显示

    //判断是否是ie浏览器
    function checkIE() {
      return (
        "-ms-scroll-limit" in document.documentElement.style &&
        "-ms-ime-align" in document.documentElement.style
      );
    }
    if (checkIE()) {
      window.addEventListener(
        "hashchange",
        () => {
          var currentPath = window.location.hash.slice(1);
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath);
          }
        },
        false
      );
    }

    if (this.isMobile) {
      //设置rem基准值
      (function (doc, win) {
        var docE1 = doc.documentElement,
          resizeEvt =
            "orientationchange" in window ? "orientationchange" : "resize",
          recalc = function () {
            var clientWidth = docE1.clientWidth;
            if (!clientWidth) return;
            docE1.style.fontSize = 100 * (clientWidth / 750) + "px";
          };

        if (!doc.addEventListener) return;
        win.addEventListener(resizeEvt, recalc, false);
        doc.addEventListener("DOMContentLoaded", recalc, false);
      })(document, window);
    }
  },
  beforeDestroy() {},
  watch:{
    $route:{
      handler:function(val,oldVal){
        const { name } = val
        this.initFixedAdv()
        if(name && ['login',
                    'forgotpassword',
                    'register',
                    'activitytemplate',
                    'account',
                    'questionaire',
                    'gifts',
                    'goodsdetail',
                    'branddetail',
                    'supplier',
                    'supplierlogin',
                    'applicationprogress',
                    'supplierforgot',
                    ].indexOf(name.toLowerCase()) != -1){
          this.isTinyAdv = true
          this.advType = 0
        } else {
          this.advType = 1
        }
        // if(name && name == 'index'){
        //   document.querySelector("html").classList.add("memorial")
        // }else{
        //   document.querySelector("html").classList.remove("memorial")
        // }
      },
      immediate:true,
      deep:true
    },
  }
};
</script>

<style>
.floatBtn {
  position: fixed;
  z-index: 9;
  bottom: 280px;
  right: 5px;
  width: 70px;
  border: 1px solid #eeeeee;
  background-color: #ffffff;
}
.floatBtn-item {
  text-align: center;
  padding: 30px 0 10px;
  font-size: 12px;
  line-height: 20px;
}
.el-breadcrumb__item:hover .is-link {
  color: #e60012;
}
#app {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.head-user .el-image__inner--center {
  transform: translate(0px) !important;
  left: 0 !important;
  right: 0 !important;
}
.headBox {
  background-color: #f0f0f0;
  height: 33px;
  overflow: hidden;
}

.head {
  height: 33px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.head-l {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #828181;
}

.head-user {
  margin-left: 80px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.head-user-avatar {
  display: block;
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.head-user img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.head-user p {
  margin-right: 10px;
}
.head-user p a {
  color: #333333;
}
.head-user p a:hover {
  color: #e60012;
}
.head-user-logo {
  margin-right: 10px;
}
.head-user-register {
  color: #e60012;
  cursor: pointer;
}

.head-r {
  display: flex;
  align-items: center;
  color: #828181;
  font-size: 14px;
}
.head-r a {
  color: #828181;
}
.head-r span,
.head-r a {
  margin: 0 5px;
  cursor: pointer;
}
.head-r a:hover {
  color: #e60012;
}
.head-r a em {
  display: block;
  position: absolute;
  top: -3px;
  right: -18px;
  border-radius: 100%;
  font-size: 9px;
  background: #e60012;
  color: #ffffff;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
}
.footer {
  background-color: #f3f3f3;
  height: 182px;
  position: relative;
  z-index: 1;
}

.footer-main {
  display: flex;
  align-items: center;
  height: 100%;
}

.footer-list {
  display: flex;
  margin-right: 60px;
}

.footer-list img {
  width: 42px;
  height: 42px;
  margin-right: 17px;
}
.footer-first-list {
  flex-shrink: 0;
}

.footer-list h1 {
  color: #242424;
  font-size: 16px;
  line-height: 42px;
  font-weight: 400;
}

.footer-list a {
  font-size: 14px;
  color: #666666;
  line-height: 20px;
  cursor: pointer;
}
.footer-list a:hover {
  color: #e60012;
}

.footer-phone {
  font-size: 20px;
  color: #242424;
  font-weight: 400;
  flex-grow: 1;
  flex-shrink: 0;
}
.footer-phone p {
  font-size: 13px;
}
.footer-phone i {
  color: #f00;
}
.footer-scan {
  margin: 0 0 0 25px;
  font-size: 12px;
  line-height: 25px;
  text-align: center;
}

.footer-scan img {
  display: block;
  width: 112px;
  height: 112px;
}

.root {
  position: relative;
  z-index: 1;
  color: #ffffff;
  background-color: #828282;
  font-size: 13px;
  /* height: 56px; */
  padding: 5px 0;
  line-height: 23px;
  text-align: center;
}
.root a {
  color: #ffffff;
}

.noData-box {
  margin-bottom: 20px;
}

.noData-box img {
  display: block;
  width: 200px;
  height: 200px;
  margin: auto;
}

.noData-box p {
  text-align: center;
  color: #999999;
  font-size: 16px;
  margin-top: 30px;
}
.pointer {
  cursor: pointer;
}
.backIndex {
  color: #e60012;
}
.footer-list-box {
  display: flex;
}
.pc_bottom_adv {
  position: fixed;
  left: 0;
  width: 100%;
  bottom: -3px;
  z-index: 9999;
  transition: left .2s cubic-bezier(.14,.68,.46,1);
  user-select: none;
}
#adv_close{
  position: absolute;
  right: 200px;
  bottom: 10%;
  font-size: 40px;
  color: #fff;
  cursor: pointer;
}
.pc_bottom_adv.hide,
.pc_bottom_fixed_adv.hide{
  left: -100%;
}
.pc_bottom_fixed_adv{
  position: fixed;
  bottom: 20px;
  left: -10px;
  z-index: 999;
  transition: left .4s cubic-bezier(.14,.68,.46,1);
  cursor: pointer;
  height: 160px;
  padding-top: 30px;
  user-select: none;
}
.pc_bottom_fixed_adv .el-image{
  width: 150px;
  height: 130px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.pc_bottom_fixed_adv:hover{
  left: 0;
}
#adv_fixed_close{
  position: absolute;
  right: 0;
  top: 5px;
  font-size: 10px;
  color: #fff;
  background: #c9c9c9;
  border-radius: 50%;
  display: block;
  padding: 5px;
}
.memorial{
  filter: grayscale(100%);
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  -webkit-filter: grayscale(1);
}
.public-security-filing {
  margin-top: 4px;
}

.public-security-icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  margin-right: 6px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue